import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { Card } from '@woovi/ui';

type Props = {
  message: string;
};

export const OrderErrorView = ({ message }: Props): ReactNode => {
  return (
    <Stack
      alignItems={'center'}
      maxWidth={'500px'}
      margin={'10px'}
      justifyContent={'center'}
    >
      <Card
        m='20px'
        p='20px'
        flexDirection='column'
        alignItems='center'
        border={'1 red'}
      >
        <Typography as={'h4'} color={'red'}>
          Ops! Ocorreu um erro
        </Typography>
        <Typography>{message}</Typography>
      </Card>
    </Stack>
  );
};
